import { render } from "./phoneInput.vue?vue&type=template&id=392708b6&scoped=true&ts=true"
import script from "./phoneInput.vue?vue&type=script&lang=ts"
export * from "./phoneInput.vue?vue&type=script&lang=ts"

import "./phoneInput.vue?vue&type=style&index=0&id=392708b6&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392708b6"]])

export default __exports__